<script lang="ts">
  import type { NavItem } from '$lib/nav';

  type IconName =
    | NavItem['icon']
    | 'user'
    | 'menu'
    | 'sun'
    | 'moon'
    | 'chevron'
    | 'spark'
    | 'eye'
    | 'eyeOff';

  let {
    name,
    size = 18,
    class: className = '',
  }: {
    name: IconName;
    size?: number;
    class?: string;
  } = $props();

  const paths: Record<IconName, string> = {
    grid: 'M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z',
    devices:
      'M7 2h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3v2h-4v-2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 2v12h10V4H7z',
    groups:
      'M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm-7 8a7 7 0 0 1 14 0H5zm14.5-9a3 3 0 1 0-3-3 3 3 0 0 0 3 3zM16 20h5a5.5 5.5 0 0 0-4.2-5.3',
    clients:
      'M3 21V7a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v12H3zm2-2h14v-8H5v8z',
    users:
      'M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4zM4 20a8 8 0 0 1 16 0H4z',
    user: 'M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4zM6 20a6 6 0 0 1 12 0H6z',
    ota: 'M12 3v10m0 0l-3.5-3.5M12 13l3.5-3.5M5 17h14v4H5v-4z',
    audit:
      'M8 4h9l3 3v13a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm1 8h8m-8 4h5',
    settings:
      'M12 8.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zM4.5 12l1.2-2.1 2.3.4 1.3-2 2 1.2L13 7h2.2l.7 2.5 2-1.2 1.3 2 2.3-.4L22 12l-1.2 2.1-2.3-.4-1.3 2-2-1.2L13.5 17H11l-.7-2.5-2 1.2-1.3-2-2.3.4L4.5 12z',
    inbox: 'M4 6h16v12H4V6zm0 4 8 5 8-5',
    menu: 'M4 7h16M4 12h16M4 17h16',
    sun: 'M12 4V2m0 20v-2M4.9 4.9 3.5 3.5m17 17-1.4-1.4M4 12H2m20 0h-2M4.9 19.1 3.5 20.5m17-17-1.4 1.4M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8z',
    moon: 'M19 14.5A7.5 7.5 0 1 1 9.5 5 6 6 0 0 0 19 14.5z',
    chevron: 'M9 6l6 6-6 6',
    spark:
      'M12 2l1.6 5.2L19 9l-5.4 1.8L12 16l-1.6-5.2L5 9l5.4-1.8L12 2zm6 10 1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3z',
    eye: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z',
    eyeOff:
      'M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22',
  };
</script>

<svg
  class={className}
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  aria-hidden="true"
>
  <path
    d={paths[name]}
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
    fill="none"
  />
</svg>
